import { render } from "./singlebreadcrumb.vue?vue&type=template&id=052e9817"
import script from "./singlebreadcrumb.vue?vue&type=script&lang=js"
export * from "./singlebreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__